import { Menu, Phone, X } from "lucide-react";
import { useEffect, useState, type ReactNode } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navigation = [
	["Loan Programs", "/loan-programs/"],
	["How It Works", "/how-it-works/"],
	["Brokers", "/brokers/"],
	["About", "/about/"],
	["FAQs", "/faqs/"],
	["Contact", "/contact/"],
];

export function Brand() {
	return (
		<Link className="brand" to="/" aria-label="Cox Capital home">
			<span className="brand-mark" aria-hidden="true"><i /><i /><i /></span>
			<span className="brand-copy"><strong>3C COX CAPITAL</strong><small>PRIVATE MONEY FOR REAL ESTATE</small></span>
		</Link>
	);
}

export default function Layout({ children }: { children: ReactNode }) {
	const finalVisual = import.meta.env.VITE_APP_ENVIRONMENT !== "TEST";
	const [open, setOpen] = useState(false);
	const location = useLocation();
	useEffect(() => { setOpen(false); window.scrollTo({ top: 0, behavior: "instant" }); }, [location.pathname]);
	useEffect(() => {
		if (!open) return;
		const closeOnEscape = (event: KeyboardEvent) => { if (event.key === "Escape") setOpen(false); };
		window.addEventListener("keydown", closeOnEscape);
		return () => window.removeEventListener("keydown", closeOnEscape);
	}, [open]);

	return (
		<div className="site-shell">
			<a className="skip-link" href="#main">Skip to content</a>
			{!finalVisual && <div className="preview-ribbon" role="note"><div className="container"><span><strong>TEST ENVIRONMENT — Do not enter real borrower information.</strong> This is not the live Cox Capital website.</span></div></div>}
			<div className="utility-bar"><div className="container"><span>Business-purpose real estate financing</span><a href="tel:+19165055663"><Phone size={14} /> 916-505-5663</a></div></div>
			<header className="site-header">
				<div className="container header-inner">
					<Brand />
					<nav id="primary-navigation" className={open ? "main-nav is-open" : "main-nav"} aria-label="Primary navigation">
						{navigation.map(([label, path]) => <NavLink key={path} to={path}>{label}</NavLink>)}
						<Link className="button button-primary nav-cta" to="/application/">Apply Now</Link>
					</nav>
					<button type="button" className="menu-button" aria-label={open ? "Close menu" : "Open menu"} aria-controls="primary-navigation" aria-expanded={open} onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
				</div>
			</header>
			<main id="main">{children}</main>
			<footer className="site-footer">
				<div className="container footer-grid">
					<div><Brand /><p>Experienced, responsive private-money and business-purpose real estate financing.</p></div>
					<div><h2>Explore</h2><Link to="/loan-programs/">Loan Programs</Link><Link to="/how-it-works/">How It Works</Link><Link to="/resources/">Resources</Link><Link to="/application/">Apply Now</Link><Link to="/contact/">Contact</Link></div>
					<div><h2>Contact</h2><a href="tel:+19165055663">916-505-5663</a><a href="mailto:ccox@amcloanservicing.com">ccox@amcloanservicing.com</a><span>1016 Sweet Pea Pl<br />Roseville, CA 95747<br />Fax: 916-209-8707</span></div>
				</div>
				<div className="container footer-legal"><span>{!finalVisual && <>Stage 3B isolated test environment — not approved for production<br /></>}© {new Date().getFullYear()} 3C Cox Capital.</span><span>DRE 02045327 | NMLS 2248508<br />DRE 01884300 | NMLS 571079</span><span className="footer-legal-links"><Link to="/legal/">Legal & Disclosures</Link><Link to="/privacy-policy-2/">Privacy Policy</Link><Link to="/terms-of-use/">Terms of Use</Link><Link to="/do-not-sell-my-info/">California Privacy Requests</Link></span></div>
			</footer>
		</div>
	);
}
